import React from "react";
import { Modal } from "semantic-ui-react";
let ModalContext;
let { Provider } = (ModalContext = React.createContext());

const useModal = () => {
    let [modal, setModal] = React.useState(false);
    let [modalContent, setModalContent] = React.useState();

    let handleModal = (content = false) => {
        setModal(!modal);
        if (content) {
            setModalContent(content);
        }
    };

    return { modal, handleModal, modalContent };
};

let ModalProvider = ({ children }) => {
    let { modal, handleModal, modalContent } = useModal();
    return (
        <Provider value={{ modal, handleModal, modalContent }}>
            <Modal onClose={() => handleModal()}
            open={modal}
                   children={modalContent}
            />
            {children}
        </Provider>
    );
};

export { ModalContext, ModalProvider, useModal };